<template>
  <div class="fff-modal upgrade-modal">
    <div
      class="overlay"
      @click="hide"
    />
    <div class="box">
      <div
        class="close-modal"
        @click="hide"
      >
        &times;
      </div>
      <div class="field">
        <h2>That's a Premium Feature!</h2>
      </div>
      <div class="field">
        <p>You've found a feature that's only available to Premium users.  You're on the Free plan, which gives you all the basic benefits of FFF without the bells and whistles.  Upgrade to the Premium plan today to unlock more.</p>
      </div>
      <div class="field">
        <div class="button-container">
          <a
            href="/account/subscriptions"
            class="button"
          >Yes Please!</a>
          <a
            class="button secondary"
            @click="hide"
          >No Thank You</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    show() {
      this.$emit('show-modal');
    },
    hide() {
      this.$emit('hide-modal');
    },
  },
}
</script>